import React, { useState, useRef, useEffect } from "react";
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const questions = [
  {
    text: "🥭 Harry had 10 mangoes. She bought 5 more. How many mangoes does she have now",
    answer: 15,
    emoji: "🥭",
  },
  {
    text: "🐶 Tom has 6 dogs. 2 ran away. How many dogs are left?",
    answer: 4,
    emoji: "🐶",
  },
  {
    text: "🎈 There are 4 balloons. Mia gets 3 more. How many balloons does she have?",
    answer: 7,
    emoji: "🎈",
  },
  {
    text: "🍭 Leo had 10 candies. He gave 4 to his friend. How many does he have now?",
    answer: 6,
    emoji: "🍭",
  },
  {
    text: "🚗 There are 3 cars in the garage and 2 more arrive. How many cars now?",
    answer: 5,
    emoji: "🚗",
  },
  {
    text: "🦋 There are 8 butterflies on a flower. 5 more joined them. How many butterflies in total?",
    answer: 13,
    emoji: "🦋 ",
  },
  {
    text: "🍪 Sarah baked 12 cookies and ate 3. How many cookies are left?",
    answer: 9,
    emoji: "🍪",
  },
  {
    text: "🎲 A game has 9 players. 4 new players joined. How many are playing now",
    answer: 13,
    emoji: "🎲",
  },
  {
    text: "🎒 There are 15 bags in a room. 7 are red and the rest are blue. How many are blue?",
    answer: 8,
    emoji: "🎒",
  },
  {
    text: "🐠 There are 10 fish in a tank. 6 are taken out. How many fish are left?",
    answer: 4,
    emoji: "🐠",
  },
  {
    text: "🍕 A pizza has 12 slices. If 3 friends share it equally, how many slices each?",
    answer: 4,
    emoji: "🍕",
  },{
    text: "🚴‍♂️ John cycled 8 km in the morning and 7 km in the evening. How far did he ride?",
    answer: 15,
    emoji: "🚴‍♂️",
  },{
    text: "🎟️ There are 25 movie tickets. 9 are sold. How many are left?",
    answer: 16,
    emoji: "🎟️",
  },{
    text: "🍊 Lily picked 18 oranges. She gave 5 to her neighbor. How many does she have now?",
    answer: 13,
    emoji: "🍊",
  },{
    text: "📚 There are 24 books on the shelf. 8 fall down. How many are still on the shelf",
    answer: 16,
    emoji: "📚",
  },{
    text: "⚽ A football team scored 14 goals in 2 matches. If they scored 6 in the first match, how many in the second",
    answer: 8,
    emoji: "⚽",
  },{
    text: "🍓 Mia has 28 strawberries. She packs 4 in each box. How many boxes can she fill?",
    answer: 7,
    emoji: "🍓",
  },{
    text: "🎢 A roller coaster has 32 seats. 18 are filled. How many are still empty",
    answer: 14,
    emoji: "🎢",
  },{
    text: "🧩 There are 36 puzzle pieces. 9 are missing. How many pieces are there now?",
    answer: 27,
    emoji: "🧩",
  },{
    text: "🚀 A rocket travels 25 km in 1 minute. How far will it go in 4 minutes?",
    answer: 100,
    emoji: "🚀",
  },
];


const styles = {
  body: {
    margin: 0,
    fontFamily: "'Comic Sans MS', cursive",
    background: "linear-gradient(to bottom right, #d0f4f5, #f7d1ff)",
    textAlign: "center",
    color: "#333",
    minHeight: "100vh",
    padding: "1rem",
    boxSizing: "border-box"
  },
  header: {
    backgroundColor: "#6a4c93",
    padding: 20,
    fontSize: "clamp(1.5rem, 4vw, 2rem)",
    color: "white",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    borderRadius: "0.5rem",
  },
  container: {
    maxWidth: 900,
    margin: "20px auto",
    padding: 20,
  },
  card: {
    backgroundColor: "#fff",
    padding: "clamp(1rem, 2vw, 2rem)",
    borderRadius: 25,
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  },
  question: {
    fontSize: "clamp(1rem, 2vw, 1.5rem)",
    margin: "25px 0",
  },
  input: {
    padding: 10,
    fontSize: "1.2rem",
    width: "50%",
    maxWidth: 150,
    borderRadius: 10,
    border: "2px solid #a066d1",
  },
  button: {
    margin: "15px 8px",
    padding: "12px 28px",
    fontSize: "1rem",
    border: "none",
    borderRadius: 14,
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
  checkBtn: {
    backgroundColor: "#38b000",
    color: "white",
  },
  nextBtn: {
    backgroundColor: "#ff006e",
    color: "white",
  },
  result: {
    fontSize: "1.2rem",
    marginTop: 20,
    fontWeight: "bold",
    minHeight: 30,
  },
  emoji: {
    fontSize: 50,
    marginTop: 10,
    animation: "bounce 1s infinite alternate",
  },
};

export default function MediumMathMissions() {
  const [currentQuestion, setCurrentQuestion] = useState(questions[0]);
  const [userAnswer, setUserAnswer] = useState("");
  const [result, setResult] = useState("");
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);

  const generateQuestion = () => {
    const q = questions[Math.floor(Math.random() * questions.length)];
    setCurrentQuestion(q);
    setUserAnswer("");
    setResult("");
  };

  const checkAnswer = () => {
    const answerNum = parseInt(userAnswer);
    if (isNaN(answerNum)) {
      setResult("❗ Please enter a number!");
      return;
    }
    if (answerNum === currentQuestion.answer) {
      setResult("✅ Well done!");
      if (correctSoundRef.current) correctSoundRef.current.play();

      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setResult(`❌ Not quite! The correct answer is ${currentQuestion.answer}.`);
      if (wrongSoundRef.current) wrongSoundRef.current.play();
    }
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  return (
    <>
      <style>{`
        @keyframes bounce {
          from { transform: translateY(0); }
          to { transform: translateY(-12px); }
        }
        button:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div style={styles.body}>
        <header style={styles.header}>🎯 Medium Math Missions</header>
        <div style={styles.container}>
          <div style={styles.card}>
            <div style={styles.emoji}>{currentQuestion.emoji}</div>
            <div style={styles.question} dangerouslySetInnerHTML={{ __html: currentQuestion.text }} />
            <div style={{ display: 'flex', justifyContent: 'center' }} >
              <input
                type="number"
                placeholder="Your answer"
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                style={styles.input}
              /></div>
            <br />
            <button onClick={checkAnswer} style={{ ...styles.button, ...styles.checkBtn }}>✅ Check</button>
            <button onClick={generateQuestion} style={{ ...styles.button, ...styles.nextBtn }}>🔁 Next</button>
            <div style={styles.result}>{result}</div>
          </div>
        </div>

        <audio ref={correctSoundRef} src="https://cdn.pixabay.com/download/audio/2023/05/15/audio_60b3d7b7dd.mp3?filename=correct-answer-133315.mp3" />
        <audio ref={wrongSoundRef} src="https://cdn.pixabay.com/download/audio/2022/03/15/audio_49d682b7f5.mp3?filename=wrong-3-199276.mp3" />
      </div>
    </>
  );
}
